import React from 'react'
import { connect } from 'react-redux'
import { TranslationResult as BingTranslationResult } from '../../../../api/bingTranslatorApi'
import TranslationItem, { TranslationItemOwnProps } from '../translationItem'
import './translationsList.scss'

export interface TranslationResultProps {
    translationResult: BingTranslationResult
}

class TranslationResult extends React.Component<TranslationResultProps> {
    render() {
        let posTranslationsMap: {
            [pos: string]: TranslationItemOwnProps[]
        } = {};

        for (let translation of this.props.translationResult.translations) {
            if (posTranslationsMap[translation.posTag] === undefined) {
                posTranslationsMap[translation.posTag] = [];
            }

            posTranslationsMap[translation.posTag].push({
                targetTranslation: translation.displayTarget,
                backTranslations: translation.backTranslations.map(bt => bt.displayText),
                original: this.props.translationResult.displaySource
            });
        }


        const renderItem = (item: TranslationItemOwnProps) => <TranslationItem key={item.targetTranslation} {...item} />

        const renderPosGroup = (posName: string, items: TranslationItemOwnProps[]) => {
            return (
                <div key={posName} className="PartOfSpeechGroup">
                    <h2 className="PartOfSpeechGroup_Name">{posName}</h2 >
                    <div className="PartOfSpeech__ItemsContainer">
                        {items.map(renderItem)}
                    </div>
                </div>
            );
        };

        return (
            <div className="TranslationList">
                {Object.keys(posTranslationsMap).map(pos => renderPosGroup(pos, posTranslationsMap[pos]))}
            </div>
        );
    }
}

const mapProps = (_state: any, ownProps: TranslationResultProps) => ownProps;

export default connect(mapProps)(TranslationResult)